module.exports = __webpack_public_path__ + "img/summary_market.ea2469e.svg";